export default __webpack_public_path__ + "static/media/exampleHaiku.c5e14261.png";